import { BrowserRouter } from "react-router-dom";
import ClerkProviderWithRoutes from "./clerkProviderWithRoutes.tsx";
import { QueryClientProvider } from "react-query";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { queryClient } from "./shared/queryClient.ts";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.ts";
import { MainWrapper } from "components/wrappers";
import { ChatProvider } from "shared/contexts/chat.context.tsx";
//import Snowfall from "react-snowfall";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <ChatProvider>
            <MainWrapper id="top-application-wrapper">
              {/*<section className="pointer-events-none absolute left-0 top-0 z-50 h-screen w-screen">
              <Snowfall color="#E9B6A4" snowflakeCount={90} />
            </section>*/}
              <ClerkProviderWithRoutes />
              <ToastContainer position="top-right" autoClose={5000} />
            </MainWrapper>
          </ChatProvider>
        </BrowserRouter>
      </I18nextProvider>
    </QueryClientProvider>
  );
}

export default App;
